import { useUserInfo } from "@today/auth"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { LoadingOverlay } from "../components/common/LoadingOverlay"
import { ORDERS_HIDDEN_CLIENT_IDS } from "../utils/clientIdGroups"

export default function HomePage() {
  const router = useRouter()
  const { isAuthenticated, clientId } = useUserInfo()

  useEffect(() => {
    if (!isAuthenticated || !clientId) return
    if (ORDERS_HIDDEN_CLIENT_IDS.includes(clientId)) {
      router.replace("/cs/tickets")
    } else {
      router.replace("/orders")
    }
  }, [isAuthenticated, clientId, router])

  return <LoadingOverlay />
}
